<template>
  <div class="login-page">
    <!-- Toast 提示 -->
    <div v-if="showToast" class="toast" :class="toastType">
      <span>{{ toastMessage }}</span>
    </div>

    <div class="container">
      <div class="login-container">
        <div class="login-card">
          <h2 class="login-title">登录闪讯达</h2>
          <p class="login-subtitle">欢迎回来，请登录您的账户</p>

          <form @submit.prevent="handleLogin" class="login-form">
            <!-- 手机号 -->
            <div class="form-group">
              <label for="phone">手机号</label>
              <div class="input-with-icon">
                <input
                  type="tel"
                  id="phone"
                  v-model="form.phone"
                  placeholder="请输入手机号"
                  maxlength="11"
                  required
                />
              </div>
            </div>

            <!-- 密码 -->
            <div class="form-group">
              <label for="password">密码</label>
              <div class="input-with-icon">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  id="password"
                  v-model="form.password"
                  placeholder="请输入密码"
                  required
                />
                <button
                  type="button"
                  class="toggle-password"
                  @click="showPassword = !showPassword"
                >
                  <svg viewBox="0 0 24 24" width="20" height="20">
                    <path
                      v-if="showPassword"
                      d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                      fill="currentColor"
                    />
                    <path
                      v-else
                      d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <!-- 记住我 -->
            <div class="form-options">
              <label class="checkbox-label">
                <input type="checkbox" v-model="form.remember" />
                <span>记住我</span>
              </label>
            </div>

            <!-- 提交按钮 -->
            <button type="submit" class="submit-btn" :disabled="loading">
              {{ loading ? "登录中..." : "登录" }}
            </button>

            <!-- 注册链接 -->
            <div class="register-link">
              还没有账户？
              <button type="button" @click="goRegister">立即注册</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginPage",
  props: {
    logoUrl: {
      type: String,
      default: "",
    },
  },
  emits: ["login-success", "go-back", "go-register"],
  data() {
    return {
      form: {
        phone: "",
        password: "",
        remember: false,
      },
      showPassword: false,
      loading: false,
      // Toast 相关
      showToast: false,
      toastMessage: "",
      toastType: "success", // success, error, info
      toastTimer: null,
    };
  },
  mounted() {
    // 检查是否有记住的账号
    const remember = localStorage.getItem("user_remember");
    if (remember === "true") {
      const savedPhone = localStorage.getItem("user_phone");
      if (savedPhone) {
        this.form.phone = savedPhone;
        this.form.remember = true;
      }
    }

    // 检查当前是否有已登录用户
    this.checkCurrentUser();
  },
  beforeUnmount() {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  },
  methods: {
    // 显示 Toast 提示
    showToastMessage(message, type = "info") {
      // 清除已有的定时器
      if (this.toastTimer) {
        clearTimeout(this.toastTimer);
      }

      this.toastMessage = message;
      this.toastType = type;
      this.showToast = true;

      // 3秒后自动隐藏
      this.toastTimer = setTimeout(() => {
        this.showToast = false;
      }, 3000);
    },

    // 检查当前登录状态
    async checkCurrentUser() {
      try {
        const Bmob = this.$bmob;
        if (!Bmob) return;

        // 获取当前用户信息
        const currentUser = await Bmob.User.current();
        if (currentUser && currentUser.objectId) {
          // 如果已登录，直接跳转到首页
          console.log("检测到已登录用户:", currentUser);
          this.handleLoginSuccess(currentUser);
        }
      } catch (error) {
        console.log("当前无登录用户或登录已过期");
      }
    },

    goRegister() {
      this.$emit("go-register"); // 修改：触发go-register事件，跳转到注册页面
    },

    async handleLogin() {
      if (!this.form.phone || !this.form.password) {
        this.showToastMessage("请填写完整信息", "error");
        return;
      }

      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.showToastMessage("请输入正确的手机号", "error");
        return;
      }

      this.loading = true;

      try {
        const Bmob = this.$bmob;
        if (!Bmob) {
          throw new Error("系统初始化异常");
        }

        console.log("开始登录，用户名:", this.form.phone);

        // 使用Bmob.User.login方法登录
        const user = await Bmob.User.login(this.form.phone, this.form.password);
        console.log("登录成功:", user);

        if (!user || !user.objectId) {
          throw new Error("登录失败，未返回用户信息");
        }

        // 登录成功，更新本地缓存
        await this.updateUserStorage(user.objectId);

        // 显示成功提示
        this.showToastMessage("登录成功！", "success");

        // 延迟触发登录成功事件
        setTimeout(() => {
          this.$emit("login-success", {
            phone: this.form.phone,
            userId: user.objectId,
            sessionToken: user.sessionToken,
            username: user.username || this.form.phone,
          });
        }, 1500);
      } catch (error) {
        // 在handleLogin方法的catch块中修改：
        console.error("登录失败:", error);
        let errorMsg = "登录失败";

        // Bmob返回的错误可能在不同属性中
        if (error && error.error) {
          // 直接使用error.error作为错误信息
          const errMsg = String(error.error).toLowerCase();
          if (errMsg.includes("username") || errMsg.includes("password")) {
            errorMsg = "手机号或密码错误";
          } else if (
            errMsg.includes("user not found") ||
            errMsg.includes("用户不存在")
          ) {
            errorMsg = "用户不存在，请先注册";
          } else if (errMsg.includes("locked")) {
            errorMsg = "账户已被锁定，请联系管理员";
          } else if (errMsg.includes("network")) {
            errorMsg = "网络连接失败，请检查网络";
          } else {
            errorMsg = "登录失败，请稍后重试";
          }
        } else if (error && error.message) {
          // 处理其他错误消息
          const errMsg = String(error.message).toLowerCase();
          if (errMsg.includes("network error")) {
            errorMsg = "网络连接失败，请检查网络";
          } else if (errMsg.includes("timeout")) {
            errorMsg = "请求超时，请稍后重试";
          } else {
            errorMsg = error.message;
          }
        }

        this.showToastMessage(errorMsg, "error");
      } finally {
        this.loading = false;
      }
    },

    // 更新用户缓存
    async updateUserStorage(objectId) {
      try {
        const Bmob = this.$bmob;
        if (!Bmob || !objectId) return;

        console.log("更新用户缓存，objectId:", objectId);

        // 更新用户缓存
        const updatedUser = await Bmob.User.updateStorage(objectId);
        console.log("用户缓存更新成功:", updatedUser);

        // 保存用户信息到本地存储
        if (updatedUser) {
          localStorage.setItem("user_token", updatedUser.sessionToken || "");
          localStorage.setItem("user_phone", this.form.phone);
          localStorage.setItem("user_id", updatedUser.objectId || "");
          localStorage.setItem(
            "user_name",
            updatedUser.username || this.form.phone
          );
          localStorage.setItem("user_remember", this.form.remember.toString());

          // 保存用户对象到本地存储（完整信息）
          localStorage.setItem("user_object", JSON.stringify(updatedUser));
        }
      } catch (error) {
        console.error("更新用户缓存失败:", error);
        // 即使更新缓存失败，也继续使用基础信息
        localStorage.setItem("user_token", "");
        localStorage.setItem("user_phone", this.form.phone);
        localStorage.setItem("user_id", "");
        localStorage.setItem("user_name", this.form.phone);
        localStorage.setItem("user_remember", this.form.remember.toString());
      }
    },

    // 处理登录成功
    handleLoginSuccess(userData) {
      // 保存用户信息
      localStorage.setItem("user_token", userData.sessionToken || "");
      localStorage.setItem("user_phone", userData.phone);
      localStorage.setItem("user_id", userData.userId || "");
      localStorage.setItem("user_name", userData.username || userData.phone);
      localStorage.setItem("user_remember", this.form.remember.toString());
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: calc(80vh - 180px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  position: relative;
}

/* Toast 样式 */
.toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 24px;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease, fadeOut 0.3s ease 2.7s;
  animation-fill-mode: forwards;
  min-width: 200px;
  text-align: center;
}

.toast.success {
  background-color: #52c41a;
}

.toast.error {
  background-color: #ff4d4f;
}

.toast.info {
  background-color: #1890ff;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translate(-50%, -20px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  to {
    opacity: 0;
    transform: translate(-50%, -20px);
  }
}

.login-container {
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-card {
  width: 100%;
  max-width: 400px;
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.login-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  text-align: center;
}

.login-subtitle {
  color: #666;
  text-align: center;
  margin-bottom: 32px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.input-with-icon {
  position: relative;
}

.input-with-icon .input-prefix {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  font-size: 14px;
}

.input-with-icon input {
  padding-left: 60px;
}

input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s;
}

input:focus {
  outline: none;
  border-color: #540cfa;
  box-shadow: 0 0 0 2px rgba(84, 12, 250, 0.1);
}

.toggle-password {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 4px;
}

.form-options {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
}

.checkbox-label input {
  width: auto;
  margin: 0;
}

.submit-btn {
  padding: 14px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.register-link {
  text-align: center;
  color: #666;
  font-size: 14px;
}

.register-link button {
  background: none;
  border: none;
  color: #540cfa;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .login-page {
    padding: 20px 15px;
    min-height: calc(80vh - 140px);
  }

  .login-card {
    padding: 30px 20px;
    max-width: 100%;
    margin: 0 10px;
  }

  .login-title {
    font-size: 24px;
  }

  .login-subtitle {
    font-size: 14px;
    margin-bottom: 24px;
  }

  .input-with-icon input {
    padding: 12px 16px 12px 60px;
    font-size: 16px; /* 移动端防止放大 */
  }

  .form-group label {
    font-size: 14px;
  }

  .submit-btn {
    padding: 16px;
    font-size: 16px;
  }

  .toast {
    top: 10px;
    left: 10px;
    right: 10px;
    transform: none;
    min-width: auto;
    font-size: 13px;
    padding: 10px 16px;
  }
}

@media (max-width: 576px) {
  .login-card {
    padding: 20px 15px;
    border-radius: 12px;
  }

  .login-title {
    font-size: 22px;
  }

  .form-options {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .login-form {
    gap: 16px;
  }
}
</style>